import { useState, useEffect } from "react";
import TodoForm from "../TodoForm/TodoForm";
import TodoList from "../TodoList/TodoList";
import styles from "../mainPage.module.css";
const TodoApp = ({ todos, setTodos, allUserTag }) => {
  const addTodoHandler = (input, price, valJazebe) => {
    const newTodo = {
      id: Math.floor(Math.random() * 1000),
      text: input,
      price: price,
      user_tag_id: valJazebe,
    };
    setTodos([...todos, newTodo]);
  };

  return (
    <div className={styles.inputBox2}>
      <TodoForm addTodoHandler={addTodoHandler} allUserTag={allUserTag} />
      <TodoList todos={todos} />
    </div>
  );
};

export default TodoApp;
